module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"warehouse-at":"{address}の倉庫","address":"所在地","location":"立地","min-from-location":"{locationName}から{min}分","comma-space":"、","contact-warehouse":"この倉庫に問い合わせ","weekdays":"月〜金","saturdays":"土曜","sundays":"日曜","holidays":"祝日","delivery":{"self":"路線便"}}}')
  delete Component.options._Ctor
}
